var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePictureUploadBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.143 24a6.857 6.857 0 1 0 0-13.714 6.857 6.857 0 0 0 0 13.714Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 4.286A4.285 4.285 0 0 0 43.714 0H4.286A4.286 4.286 0 0 0 0 4.286v39.428A4.286 4.286 0 0 0 4.286 48h39.428A4.285 4.285 0 0 0 48 43.714V4.286Zm-6 .857a.857.857 0 0 1 .857.857v22.423a.858.858 0 0 1-.514.788.858.858 0 0 1-.926 0l-6.24-5.931a3.874 3.874 0 0 0-5.314.206l-11.486 12.24a.926.926 0 0 1-.651.274H6a.857.857 0 0 1-.857-.857V6A.857.857 0 0 1 6 5.143h36Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePictureUploadBold);
export default __webpack_public_path__ + "static/media/image-picture-upload-bold.0ff032b4f2a1715ae56d36d28b06e2c0.svg";
export { ForwardRef as ReactComponent };